
import type { Database } from "@/integrations/supabase/types";
import { CollectionCard } from "./CollectionCard";

type Collection = Database['public']['Tables']['collections']['Row'] & {
  creator: {
    name: string;
    surname: string;
  } | null;
  collection_artworks: {
    artwork: {
      artwork_id: number;
      title: string;
      preview: string;
    };
  }[];
};

interface CollectionGridProps {
  collections: Collection[];
}

export function CollectionGrid({ collections }: CollectionGridProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {collections.map((collection) => (
        <CollectionCard key={collection.collection_id} collection={collection} />
      ))}
    </div>
  );
}
